/**
 * Removes credential-bearing query strings before a URL reaches Sentry.
 *
 * Sentry never scrubs URLs server-side (only request/response bodies), and Session Replay records the
 * URL of every fetch, XHR and resource load. S3 presigned URLs carry `X-Amz-Signature` /
 * `X-Amz-Security-Token`, so they must be stripped in the browser.
 *
 * Default-deny: anything not on an Ankar origin loses its query and fragment entirely.
 */
const ANKAR_HOST = /(^|\.)ankar(-dev)?\.ai$/;

export const scrubUrl = (url: string): string => {
  try {
    const parsed = new URL(url, window.location.origin);
    if (ANKAR_HOST.test(parsed.hostname)) return url;
    parsed.search = '';
    parsed.hash = '';
    return parsed.toString();
  } catch {
    // Unparseable URL: drop everything after the first delimiter rather than risk leaking it.
    return url.split(/[?#]/)[0];
  }
};
